import { render } from "./Wheelchairs.vue?vue&type=template&id=1b5cb3eb&scoped=true"
import script from "./Wheelchairs.vue?vue&type=script&lang=js"
export * from "./Wheelchairs.vue?vue&type=script&lang=js"

import "./Wheelchairs.vue?vue&type=style&index=0&id=1b5cb3eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5cb3eb"]])

export default __exports__